import { render, staticRenderFns } from "./PostIndexModalComponent.vue?vue&type=template&id=5e6837d0&scoped=true"
import script from "./PostIndexModalComponent.vue?vue&type=script&lang=js"
export * from "./PostIndexModalComponent.vue?vue&type=script&lang=js"
import style0 from "./PostIndexModalComponent.vue?vue&type=style&index=0&id=5e6837d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6837d0",
  null
  
)

export default component.exports